exports.source = require('./source');
exports.through = require('./through');
exports.sink = require('./sink');
exports.duplex = require('./duplex');